import { RequiredMark } from './styled-components'

interface RequiredLabelProps {
  label: string
  required?: boolean
}

const RequiredLabel = ({ label, required = true }: RequiredLabelProps) => {
  if (!required) return <>{label}</>

  return (
    <span>
      <RequiredMark>*</RequiredMark>
      {` ${label}`}
    </span>
  )
}

export default RequiredLabel
